import React from 'react';
import DataGrid from 'features/shared/components/dataGrid/DataGrid';
import ContractulAccountSimplifiedHeader from 'features/contractualAccounts/components/ContractulAccountSimplifiedHeader';
import { Customer_ContractualAccounts } from 'data/endpoints';
import ContractulAccountSimplified from 'features/contractualAccounts/components/ContractulAccountSimplified';
import { DataGridId } from 'features/shared/components/dataGrid/DataGridId';
import { loadConfiguration, loadDataSortConfig } from 'features/shared/helpers/modules';

const contractualAccountsDataFilterJson = loadConfiguration("datafilters/contractualAccountsDataFilter.json");
const contractualAccountsDataSortJson = loadDataSortConfig("contractualAccountsDataSort");

interface Props {
  
}

const ContractualAccountsSection = (props: Props) => {
  return (
    <DataGrid
      gridId={DataGridId.contractualAccountsGrid}
      url={Customer_ContractualAccounts}
      filterJson={contractualAccountsDataFilterJson}
      sortingJson={contractualAccountsDataSortJson}
      renderItem={(item) => <ContractulAccountSimplified account={item} />}
      renderHeader={() => <ContractulAccountSimplifiedHeader />}
    />
  )
}

export default ContractualAccountsSection;
